import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const introConfig: PageConfig[] = [
  {
    name: "details",
    title: "Initiative Details",
    questions: [
      {
        type: "text",
        name: "initiativeName",
        title: "Initiative Name",
        placeHolder: "Te Kaupapa",
        isRequired: true,
      },
      {
        type: "text",
        name: "amount",
        title: "Grant Amount Received",
        placeHolder: "Te nui o te pūtea",
        isRequired: true,
        validators: [{ type: "numeric" }],
      },
    ],
  },
];
